"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var globalStyles_1 = __importDefault(require("./globalStyles"));

var Grid_1 = __importDefault(require("../../Grid"));

var styled_1 = require("../styled");

var RezdyLogo_1 = __importDefault(require("../../Icon/icons/RezdyLogo"));

var Layout =
/** @class */
function (_super) {
  __extends(Layout, _super);

  function Layout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Layout.prototype.render = function () {
    var children = this.props.children;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(globalStyles_1.default, null), react_1.default.createElement(styled_1.Main, null, react_1.default.createElement(styled_1.Header, null, react_1.default.createElement(Grid_1.default.Container, {
      cols: 2,
      rows: "40px"
    }, react_1.default.createElement(Grid_1.default.Cell, {
      className: "logo"
    }, react_1.default.createElement(RezdyLogo_1.default, {
      fill: "#fff",
      height: "100%"
    })), react_1.default.createElement(Grid_1.default.Cell, {
      alignSelf: "center",
      justifySelf: "end"
    }, this.props.secondaryAction))), react_1.default.createElement(styled_1.Section, null, children)));
  };

  return Layout;
}(react_1.PureComponent);

exports.Layout = Layout;
exports.default = Layout;